import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import HeroSection from "./components/HeroSection";
import FeaturedCollections from "./components/FeaturedCollections";
import SignaturePieces from "./components/SignaturePieces";
import GalleryPreview from "./components/GalleryPreview";
import CraftsmanshipSection from "./components/CraftsmanshipSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  useScrollToTop();
  return (
    <div className="min-h-screen bg-brand-cream font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedCollections />
        <SignaturePieces />
        <GalleryPreview />
        <CraftsmanshipSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}